import Chip from 'emerald-ui/lib/Chip';
import Avatar from 'emerald-ui/lib/Avatar';
import Icon from 'emerald-ui/lib/Icon';
import photoAvatar from './assets/photo-avatar.png';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Chip, componentName: 'Chip' }], 'Chip'),
  description:
    'Chips are used to represent a value for a multi-select Select component or a single readonly value in a set of related values.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Chip },
      whiteBackground: true,
      code: `<div style={{ display: 'flex' }}>
  <Chip>
    <span>Chip</span>
  </Chip>
</div>`,
    },
    {
      title: 'Custom',
      scope: { Avatar, Chip, Icon, photoAvatar },
      whiteBackground: true,
      code: `// The following photo is real files that need to be imported

<div style={{ display: 'flex', flexWrap: 'wrap' }}>
  <Chip ariaLabel="John Doe" onDismiss={() => {}} style={{ margin: '10px' }}>
    <Avatar title="JD" />
    John Doe
  </Chip>
  <Chip ariaLabel="Manager" onDismiss={() => {}} style={{ margin: '10px' }}>
    <Icon name="face" />
    Manager
  </Chip>
  <Chip ariaLabel="John Doe" onDismiss={() => {}} style={{ margin: '10px' }}>
    <img src={photoAvatar} alt="logo" />
    John Doe
  </Chip>
</div>`,
    },
  ],
};
